import { SVGProps } from 'react';

const SvgText = (props: SVGProps<SVGSVGElement>) => (
  <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.5 3.75H10.5C8.14298 3.75 6.96447 3.75 6.23223 4.48223C5.5 5.21447 5.5 6.39298 5.5 8.75V9.9375M15.5 3.75H20.5C22.857 3.75 24.0355 3.75 24.7678 4.48223C25.5 5.21447 25.5 6.39298 25.5 8.75V9.9375M15.5 3.75V26.25"
      stroke="#2196F3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.25 26.25H21.75" stroke="#2196F3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default SvgText;
